export default [
    {
        field: 'auth_code',
        type: 'text',
        vuetifyProps: {
            label: 'Código',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'bar_auth_code',
        type: 'text',
        vuetifyProps: {
            label: 'Código de barra',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'is_pos_workstation_user',
        type: 'checkbox',
        vuetifyProps: {
            label: 'Estación de trabajo',
        },
        rules: [ 'required' ],
        value: '',
    },
    {
        field: 'created_at',
        type: 'datePicker',
        vuetifyProps: {
            label: 'Fecha de creación',
        },
        rules: [ 'required' ],
        value: '',
    },
]